/* src/routes/about/index.svelte generated by Svelte v3.30.0 */
import {
	SvelteComponent,
	add_render_callback,
	append,
	attr,
	children,
	claim_element,
	claim_space,
	claim_text,
	create_in_transition,
	create_out_transition,
	detach,
	element,
	init,
	insert,
	noop,
	safe_not_equal,
	space,
	text
} from "../../../web_modules/svelte/internal.js";

import { fade } from "../../../web_modules/svelte/transition.js";
import { customtransition } from "../../components/transition.js";

function create_fragment(ctx) {
	let div;
	let h1;
	let t0;
	let t1;
	let p;
	let t2;
	let div_intro;
	let div_outro;
	let current;

	return {
		c() {
			div = element("div");
			h1 = element("h1");
			t0 = text("About page");
			t1 = space();
			p = element("p");
			t2 = text("Some about page content goes here");
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { class: true });
			var div_nodes = children(div);
			h1 = claim_element(div_nodes, "H1", {});
			var h1_nodes = children(h1);
			t0 = claim_text(h1_nodes, "About page");
			h1_nodes.forEach(detach);
			t1 = claim_space(div_nodes);
			p = claim_element(div_nodes, "P", {});
			var p_nodes = children(p);
			t2 = claim_text(p_nodes, "Some about page content goes here");
			p_nodes.forEach(detach);
			div_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(div, "class", "content");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, h1);
			append(h1, t0);
			append(div, t1);
			append(div, p);
			append(p, t2);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;

			add_render_callback(() => {
				if (div_outro) div_outro.end(1);
				if (!div_intro) div_intro = create_in_transition(div, customtransition, {});
				div_intro.start();
			});

			current = true;
		},
		o(local) {
			if (div_intro) div_intro.invalidate();
			div_outro = create_out_transition(div, fade, {});
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (detaching && div_outro) div_outro.end();
		}
	};
}

class About extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, null, create_fragment, safe_not_equal, {});
	}
}

export default About;
//# sourceMappingURL=index.js.map
